import api from '@/utils/api';

/**
 * Get all company's temporary part numbers
 * @param {string} companyId - Company Id
 * @returns {Promise}
 */
const getCompanyTempPriceListApi = (companyId) =>
  api.get(`company/${companyId}/price/temp-part-numbers`);

export default getCompanyTempPriceListApi;
